export enum ProjectTypeRef {
  gas_station_project = "gas_station_project",
  i_c_distributed_generation_project = 'i_c_distributed_generation_project',
  utility_scale_pv_plant_project = 'utility_scale_pv_plant_project',
  wind_onshore_project = 'wind_onshore_project',
  ren_fr_pv_project = 'ren_fr_pv_project',
  ren_fr_wind_project = 'ren_fr_wind_project',
}
export enum ProjectType {
  gas_station_project = "gas_station_project",
  i_c_distributed_generation_project = 'i_c_distributed_generation_project',
  utility_scale_pv_plant_project = 'utility_scale_pv_plant_project',
  wind_onshore_project = 'wind_onshore_project',
  ren_fr_project = 'ren_fr_project',
}
